import moment from 'moment';

export const formatNextEventDate = (dateString: string): string => {
  const date = moment(dateString);
  const now = moment();

  if (date.isSame(now, 'day')) return 'Today';
  if (date.isSame(now.clone().add(1, 'day'), 'day')) return 'Tomorrow';

  const daysAway = date.diff(now, 'days');
  if (daysAway >= 0 && daysAway < 7) {
    return date.format('dddd');
  }

  return date.format('MMM D');
};
